import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

/**
 * The page's outgoing Smart Links, used to size the byline's icon reservation before paint.
 *
 * The draft field is only correct for *unpublished* content: a live doc is rendered by the editor
 * yet its content is published, so it must use `contentSmartLinks`.
 *
 * `product` is the backend's own resolution and is filled for first-party links only; it names the
 * app without a resolver call, which the SSR placeholder count relies on (CCINT-9543). ORS stays
 * authoritative for titles, icons and resource types.
 */
export const BylineSmartLinksQuery: GraphQLTaggedNode = graphql`
	query BylineSmartLinksQuery($contentId: ID!, $first: Int!, $smartLinksFromDraft: Boolean!) {
		contentSmartLinks(id: $contentId, first: $first, includeHyperlinks: true)
			@skip(if: $smartLinksFromDraft) {
			nodes {
				url
				product
			}
		}
		confluence_contentSmartLinksForDraft(id: $contentId, first: $first, includeHyperlinks: true)
			@include(if: $smartLinksFromDraft) {
			nodes {
				url
				product
			}
		}
	}
`;
